import type { Role } from '@hotjar/webapp/features/Activation/OnboardingPage/steps/OrganizationSteps/steps/OrganizationRole';

export const roles: { id: Role; value: string }[] = [
  { id: 'data analyst', value: 'Data Analyst' },
  { id: 'consultant', value: 'Consultant' },
  { id: 'digital marketer', value: 'Digital Marketer' },
  { id: 'product manager', value: 'Product Manager' },
  { id: 'ceo', value: 'CEO' },
  { id: 'product designer', value: 'Product Designer' },
  { id: 'engineer', value: 'Engineer' },
  { id: 'content designer', value: 'Content Designer' },
  { id: 'ux researcher', value: 'UX Researcher' },
  { id: 'other', value: 'Other' },
];
